export default __webpack_public_path__ + "static/results-9980b71d954373fcf2be6a2d8603ef62.webp";